import MainLayout from "../../../../components/mainLayout";
import { PAGES } from "../../../../routes";
import audio from "../../../../assets/audio/10.mp3"
export default function P1() {
    return (
        <MainLayout
            title="Powrót"
            question=""
            audio={audio}
            answers={{
                ans1: "Dalej",
            }}
            links={{
                link1: PAGES.p25,
            }}
            content={
                <div>
                    <p>
                        Kiedy w drodze powrotnej przejeżdżacie przez okoliczne łąki, niebo zasnuwa się chmurami. Czy to mgła, czy wydawało ci się, że widzisz kogoś przemykającego między brzozami nad rzeczką?
                    </p>
                    <p>
                        Wreszcie dojeżdżacie do Tarszewa. Dom Emila wygląda osobliwie, jest cały łaciaty jak krowa.
                    </p>
                    <ul>
                        <li>Pan tak pomalował dom?</li>
                        <li>Ha, robi się ciemno, to i nie widać – odpowiada i śmiejąc się, zeskakuje z wozu. – To ruda!</li>
                        <li>Ruda?</li>
                        <li>Ruda darniowa, pełno tu tego. Łatwo poznać, całe bryły z ziemi wystają. No i łatwo się trzyma z wapienną zaprawą. Mnóstwo tu takich chałup. I tu w Tarszewie, i w Olchowie na łąkach, i z drugiej strony zagórowa na Olędrach…</li>
                        <li>Olędry? Już któryś raz o tym słyszę…</li>
                        <li>Ewangelicy. Kiedyś tu łąki osuszali, wiatraki stawiali. Ale to stara historia, teraz po nich tylko wioski zostały: Wrąbczynkowskie Holendry, Zagórowskie, Myszakowskie, Łazińsk…. Będzie tego! – wymienia Emil. – Zapraszam, gość w dom, Bóg w dom! Czasem szukasz pracy, a przychodzi ci zbierać śliwki i spać w chałupie z rudy darniowej. Ot, zwykły dzień w Zagórowie!</li>
                    </ul>
                </div>
            }
        />

    );
}